import { chartTypes, disaggregations, periodicity } from "./enum"

export const PERIODICITY_CODE_PATTERNS = {
  [periodicity.Daily]: /^\d{4}-\d{2}-\d{2}$/,
  [periodicity.Monthly]: /^\d{4}-(0[1-9]|1[0-2])$/,
  [periodicity.Quarterly]: /^\d{4}-Q[1-4]$/,
  [periodicity.HalfYearlySemester]: /^\d{4}-S[1-2]$/,
  [periodicity.Annual]: /^\d{4}$/,
  [periodicity.Triennial]: /^\d{4}$/,
}

export const EXCLUDED_DISAGGREGATIONS = [
  disaggregations.UnitMeasure,
  disaggregations.Frequency,
  disaggregations.RefArea,
  disaggregations.TimePeriod,
  disaggregations.Region,
]

export const EXCLUDED_DISAGGREGATIONS_INDICATOR_INFO = [
  disaggregations.Frequency,
  disaggregations.RefArea,
  disaggregations.TimePeriod,
  disaggregations.Region,
]

export const NOT_APPLICABLE = "_Z"
export const TOTAL = '_T'

export const NONE = "None"

export const ALL_COUNTRIES = "All"
export const ALL_COUNTRIES_OBJECT = {
  id: 'All',
  name: 'All',
}
export const API_SUCCESS_CODE = '200'
export const API_NOT_FOUND = {
  code: 400,
  message: 'No database found for the given indicator id.',
}
export const CHART_TABS = [
  { id: chartTypes.Map, name: "Map" },
  { id: chartTypes.Trend, name: "Trend" },
  { id: chartTypes.Correlation, name: "Correlation" },
  { id: chartTypes.Bar, name: "Bar" },
  { id: chartTypes.DataTable, name: "Data Table" },
  { id: chartTypes.StackedBar, name: "Stacked Bar" },
  { id: chartTypes.Pie, name: "Pie" },
]

export const INCOME_GROUPS_ORDER = [
  "LIC",
  "LMC",
  "LMY",
  "MIC",
  "MIX",
  "UMC",
  "HIC",
]

export const GROUP_ORDER = [
  "AGGREGATE",
  "WORLD",
  "REGION",
  "REGION_UN",
  "LENDING",
  "INCOME",
  "OTHER",
]

export const LINE_CHART_OPTIONS = {
  chart: {
    type: "line",
    height: "100%",
  },
  tooltip: {
    shared: true,
  },
  exporting: {
    // allowHTML: true,
    buttons: {
      contextButton: {
        menuItems: [
          "viewFullscreen",
          "downloadPNG",
          "downloadJPEG",
          "downloadSVG",
          "printChart",
        ],
      },
    },
  },
  title: {
    text: null,
  },
  subtitle: {
    text: null,
  },
  xAxis: {
    title: {
      text: null,
    },
  },
  yAxis: {
    title: {
      text: null,
    },
    labels: {
      format: "{text}",
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: true,
    // maxHeight: 80,
  },
  plotOptions: {
    series: {
      // connectNulls: true,
      marker: {
        enabled: false,
      },
      lineWidth: 4,
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 350,
        },
        chartOptions: {
          xAxis: {
            labels: {
              step: 5,
            },
          },
        },
      },
    ],
  },
}
export const BAR_CHART_OPTIONS = {
  tooltip: {
    shared: true,
  },
  exporting: {
    // allowHTML: true,
    buttons: {
      contextButton: {
        menuItems: [
          'viewFullscreen',
          'downloadPNG',
          'downloadJPEG',
          'downloadSVG',
          'printChart',
        ],
      },
    },
  },
  title: {
    text: null,
  },
  subtitle: {
    text: null,
  },
  xAxis: {
    title: {
      text: null,
    },
  },
  yAxis: {
    title: {
      text: null,
    },
    labels: {
      format: '{text}',
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
}
export const SCATTER_CHART_OPTIONS = {
  chart: {
    type: "scatter",
    height: "600",
    className: "scatter-plot",
  },
  title: {
    text: null,
  },
  subtitle: {
    text: null,
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  tooltip: { enabled: true },
  plotOptions: {
    scatter: {
      animation: false,
    },
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: [
          "viewFullscreen",
          "downloadPNG",
          "downloadJPEG",
          "downloadSVG",
          "printChart",
        ],
      },
    },
  },
}

export const CORRELATION_NONE_INDICATOR_VALUE = {
  id: "None",
  name: "None",
}

export const ONLY_SHOW_DEFAULT = "ALL"

export const WORLD_DEFAULT = { id: "WLD", name: "World" }

export const DEFAULT_BIN_COLORS = 7

export const UNIT_MEASURE_EXCEPTION = ["T", "W_POP", "BITS", "BIT_S_IU"]

export const UNITS = {
  T: [
    { limit: 1_000, factor: 1_000, suffix: "Kt" },
    { limit: 1_000_000, factor: 1_000_000, suffix: "Mt" },
    { limit: 1_000_000_000, factor: 1_000_000_000, suffix: "Gt" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Tt" },
  ],
  W_POP: [
    { limit: 1_000, factor: 1_000, suffix: "Kw" },
    { limit: 1_000_000, factor: 1_000_000, suffix: "Mw" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Gw" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Tt" },
  ],
  BITS: [
    { limit: 1_000, factor: 1_000, suffix: "Kb" },
    { limit: 1_000_000, factor: 1_000_000, suffix: "Mb" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Gb" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Tt" },
  ],
  BIT_S_IU: [
    { limit: 1_000, factor: 1_000, suffix: "Kb" },
    { limit: 1_000_000, factor: 1_000_000, suffix: "Mb" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Gb" },
    { limit: 1_000_000_000_000, factor: 1_000_000_000_000, suffix: "Tt" },
  ],
}
export const IS_RECENT = 'recent'

export const CATEGORICAL_UNITMEASURE = 'CAT'
export const COUNTRY_GROUPINGS = [
  'HCL_WB_REGIONS',
  'HCL_WB_INCOME',
  'HCL_WB_LENDING',
]
